import React from "react";

const Alert = () => {
  return (
    <div
      className="notifications fixed right-3 top-3 z-50 flex w-80 max-w-[92vw] flex-col gap-3 pb-2 md:w-96"
      id="notificationsAria"
    ></div>
  );
};

export const createAlert = (
  messageStatus,
  messageInfo,
  navigate = null,
  dispatch
) => {
  const alertAria = document.querySelector("#notificationsAria");
  if (!alertAria) return;

  const status = (messageStatus || "info").toLowerCase();
  const alertBody =
    navigate == null
      ? document.createElement("div")
      : document.createElement("a");

  alertBody.setAttribute("role", "alert");
  if (navigate != null) {
    alertBody.setAttribute("href", navigate);
    alertBody.setAttribute("class", "no-underline");
  }

  const wrapper = document.createElement("div");
  wrapper.setAttribute(
    "class",
    "group relative overflow-hidden rounded-2xl border px-4 py-3 pr-10 shadow-xl backdrop-blur-md transition-all duration-500 ease-out -translate-y-8 opacity-0 bg-white/90 text-slate-800 border-slate-200/80 dark:bg-slate-900/85 dark:text-slate-100 dark:border-slate-700/70"
  );

  const h5 = document.createElement("h5");
  h5.setAttribute("class", "text-sm font-semibold tracking-wide");
  h5.innerHTML =
    status == "error"
      ? document.documentElement.lang == "ar"
        ? "خطأ"
        : "Error"
      : status == "success"
      ? document.documentElement.lang == "ar"
        ? "نجاح"
        : "Success"
      : status == "warning"
      ? document.documentElement.lang == "ar"
        ? "تحذير"
        : "Warning"
      : status == "info"
      ? document.documentElement.lang == "ar"
        ? "معلومة"
        : "Info"
      : document.documentElement.lang == "ar"
      ? "إشعار"
      : "Notification";

  const span = document.createElement("span");
  span.setAttribute("class", "mt-1 block text-xs leading-relaxed opacity-90");
  span.innerHTML = messageInfo;

  const closeBtn = document.createElement("button");
  closeBtn.setAttribute("type", "button");
  closeBtn.setAttribute(
    "class",
    "absolute right-2 top-2 h-7 w-7 rounded-full text-base leading-none opacity-70 transition hover:opacity-100"
  );
  closeBtn.setAttribute(
    "aria-label",
    document.documentElement.lang == "ar" ? "إغلاق" : "Close"
  );
  closeBtn.innerText = "×";

  const progress = document.createElement("div");
  progress.setAttribute("class", "absolute bottom-0 left-0 h-1 w-full bg-black/10");
  const progressInner = document.createElement("div");
  progressInner.setAttribute("class", "h-full w-full bg-current opacity-35");
  progress.appendChild(progressInner);

  const colorMap = {
    error:
      "border-red-300/80 bg-red-50/90 text-red-800 dark:border-red-500/35 dark:bg-red-500/10 dark:text-red-100",
    success:
      "border-emerald-300/80 bg-emerald-50/90 text-emerald-800 dark:border-emerald-500/35 dark:bg-emerald-500/10 dark:text-emerald-100",
    info:
      "border-sky-300/80 bg-sky-50/90 text-sky-800 dark:border-sky-500/35 dark:bg-sky-500/10 dark:text-sky-100",
    warning:
      "border-amber-300/80 bg-amber-50/90 text-amber-800 dark:border-amber-500/35 dark:bg-amber-500/10 dark:text-amber-100",
    dark:
      "border-slate-400/60 bg-slate-100/90 text-slate-800 dark:border-slate-700/50 dark:bg-slate-900/75 dark:text-slate-100",
    light:
      "border-slate-300/70 bg-white/95 text-slate-700 dark:border-slate-500/50 dark:bg-slate-800/80 dark:text-slate-100",
    primary:
      "border-indigo-300/80 bg-indigo-50/90 text-indigo-800 dark:border-indigo-500/35 dark:bg-indigo-500/10 dark:text-indigo-100",
    secondary:
      "border-cyan-300/80 bg-cyan-50/90 text-cyan-800 dark:border-cyan-500/35 dark:bg-cyan-500/10 dark:text-cyan-100",
  };

  const messageStatusClass = colorMap[status] || colorMap.primary;
  wrapper.classList.add(...messageStatusClass.split(" "));

  wrapper.appendChild(h5);
  wrapper.appendChild(span);
  wrapper.appendChild(closeBtn);
  wrapper.appendChild(progress);
  alertBody.appendChild(wrapper);

  alertAria.insertBefore(alertBody, alertAria.firstChild);

  setTimeout(() => {
    wrapper.classList.remove("-translate-y-8", "opacity-0");
    progressInner.style.transition = "width 5s linear";
    progressInner.style.width = "0%";
  }, 100);

  const hideAndRemove = () => {
    wrapper.classList.add("-translate-y-8", "opacity-0");
    setTimeout(() => {
      alertBody.remove();
    }, 900);
  };

  alertBody.addEventListener("click", hideAndRemove);
  closeBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    hideAndRemove();
  });

  let time2;
  let time1 = setTimeout(() => {
    hideAndRemove();
    time2 = setTimeout(() => {
      alertBody.remove();
    }, 900);
  }, 5000);

  const clearTimeoutId = () => {
    clearTimeout(time1);
    clearTimeout(time2);
  };

  alertBody.addEventListener("mouseenter", clearTimeoutId);

  alertBody.addEventListener("mouseleave", () => {
    clearTimeoutId();
    time1 = setTimeout(() => {
      hideAndRemove();
      time2 = setTimeout(() => {
        alertBody.remove();
      }, 900);
    }, 5000);
  });
};

export default Alert;
